import * as React from "react";
import { Table } from "../../../../newcomponents/table/table";
import { useTableKindId } from "../../../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../../../newcomponents/table/data/useTableItemQueryData";
import { TableHeaderRefreshButton } from "../../../../newcomponents/table/components/RefreshButton";
import { CustomTableCPLNQuery } from "../../../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionNoLinkColumn } from "../../../../newcomponents/table/columns/wellKnown/nameDescriptionNoLinkColumn";
import { TagsColumn } from "../../../../newcomponents/table/columns/wellKnown/tagsColumn";
import { CreatedColumn } from "../../../../newcomponents/table/columns/wellKnown/createdColumn";
import { LastModifiedColumn } from "../../../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { linksOf } from "../../../../services/cpln";
import { Workload } from "../../../../schema/types/workload/workload";
import { WorkloadGvcColumn } from "../../../../newcomponents/table/columns/workload/gvcColumn";

interface WorkloadTableItem extends Workload {
  type: string;
  selfLink: string;
  gvc: string;
}

interface Props {
  title: string;
  selections: string[];
  onSelectionsChange: (values: string[]) => void;
}
export const WorkloadTable: React.FC<Props> = ({ title, selections, onSelectionsChange }) => {
  const { kind, id } = useTableKindId("workload", "policy-create-target-list-workload");
  // TODO from all gvcs
  const qData = useTableItemQueryData<Workload>(kind, { fetchAllPages: true, skipGvcScope: true });

  const workloadTableItems: WorkloadTableItem[] = qData.visibleItems.map((workload) => {
    const type = workload.spec!.type;
    const selfLink = linksOf(workload).self!;
    const gvc = selfLink.split("/")[4];
    return {
      ...workload,
      type: type,
      selfLink: selfLink,
      gvc: gvc,
    };
  });

  return (
    <Table<WorkloadTableItem>
      title={title}
      data={workloadTableItems}
      tableId={id}
      selectMode="multi"
      selectKey={"selfLink"}
      selections={selections}
      onSelectionsChange={onSelectionsChange}
      headerRenderer={() => {
        return (
          <>
            <TableHeaderRefreshButton onClick={qData.fetchItems} />
            <CustomTableCPLNQuery
              tableId={id}
              kind={kind}
              onQuery={qData.setQuery}
              isLoading={qData.isLoadingQueried}
            />
          </>
        );
      }}
      enableFilter
      isLoading={qData.isLoading}
      columns={[
        NameDescriptionNoLinkColumn(),
        WorkloadGvcColumn() as any,
        TagsColumn(),
        CreatedColumn(),
        LastModifiedColumn(),
      ]}
    />
  );
};
